import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useDataContext } from "../context/datacontext";

function Header() {
  const { setTeamId, myTeamList } = useDataContext();
  console.log("myTeamList", myTeamList);
  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Container>
        <Navbar.Brand href="#home">BR Team Manager</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#squad">Squad</Nav.Link>
            <Nav.Link href="#team">Team</Nav.Link>
            <Nav.Link href="#lineup">Lineup</Nav.Link>
          </Nav>
          <Nav>
            <NavDropdown title="Details" id="collasible-nav-dropdown">
              {myTeamList.map((team) => {
                return (
                  <NavDropdown.Item
                    href="#squad"
                    key={team.id}
                    onClick={() => {
                      setTeamId(team.id);
                    }}
                  >
                    {team.name}{" "}
                    <img
                      src={`https://www.blackoutrugby.com/images/flagz/${team.country_iso.toLowerCase()}.gif`}
                    />
                  </NavDropdown.Item>
                );
              })}
              <NavDropdown.Item href="#config">Config</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
